import axios from '../../utils/axios';

export const getBlog = async (id) => {
  const response = await axios.get(`/blogs/${id}`);

  return response.data;
};

export const patchBlog = async ({ id, data }) => {
  const response = await axios.patch(`/blogs/${id}`, data);

  return response.data;
};
